"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const account_habit_1 = require("./account-habit");
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
class AccountSegment extends base_1.default {
    constructor(data = {
        id: undefined,
        account_habit: undefined,
        segment: undefined,
        date_started: undefined,
        date_completed: undefined,
    }) {
        super(data);
        this.account_habit = (0, defaults_1.defaultString)(data.account_habit);
        this.segment = (0, defaults_1.defaultString)(data.segment);
        this.date_started = (0, defaults_1.defaultString)(data.date_started);
        this.date_completed = data.date_completed;
    }
    get dateStarted() {
        return this.date_started;
    }
    get status() {
        let status = account_habit_1.HabitStates.WAITING;
        if (this.date_completed) {
            status = account_habit_1.HabitStates.COMPLETE;
        }
        else if ((0, moment_1.default)(this.date_started).isSameOrBefore(moment_1.default.now(), 'minute')) {
            status = account_habit_1.HabitStates.ACTIVE;
        }
        return status;
    }
    getStatus(accountHabit) {
        if (accountHabit && accountHabit.unlockedManually) {
            return account_habit_1.HabitStates.COMPLETE;
        }
        return this.status;
    }
    get complete() {
        return (0, moment_1.default)(this.date_completed).isBefore(moment_1.default.now());
    }
}
exports.default = AccountSegment;
